import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectCategoryList } from "../../../../store/slices/categoryListSlice";
import { getMainScreenVariant } from "../../../../config/runtimeConfig";

export const useCategoryScreen = () => {
  const list = useSelector(selectCategoryList);
  const variant = getMainScreenVariant();

  const rootList = useMemo(() => {
    if (variant === "products") return list;

    const childIds = new Set<number>();
    for (const cat of list) {
      if (cat.children?.length) {
        for (const child of cat.children) {
          if (child.id != null) childIds.add(child.id);
        }
      }
    }
    return list.filter((cat) => cat.id != null && !childIds.has(cat.id));
  }, [list, variant]);

  return { list: rootList };
};
